import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withPreloading,
  withRouterConfig,
} from '@angular/router';
import { appRoutes } from './app.routes';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule } from '@angular/forms';
import { NgChartsModule } from 'ng2-charts';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Angulartics2Module, RouterlessTracking } from 'angulartics2';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { AccountModule } from './account/account.module';
import { HttpInterceptors } from './core/interceptors';
import { RavenErrorHandler } from './core/interceptors/raven.interceptor';
import { HttpLink } from './graphql/http-link';
import { provideGraphQL } from './graphql/provide-graphql';
import CustomPrimeNgTheme from 'src/assets/theme/custom';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BrowserModule,
      NgSelectModule,
      NgxDatatableModule,
      FormsModule,
      AccountModule,
      BrowserAnimationsModule,
      NgChartsModule,
      AngularSvgIconModule.forRoot(),
      Angulartics2Module.forRoot(),
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    HttpLink,
    provideGraphQL(),
    HttpInterceptors,
    MessageService,
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    { provide: ErrorHandler, useClass: RavenErrorHandler },
    RouterlessTracking,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    providePrimeNG({
      theme: {
        preset: CustomPrimeNgTheme,
        options: {
          // Dark mode is disabled until a dark theme is designed.
          // To enable, add 'dark-mode-enabled' class to the html element.
          darkModeSelector: '.dark-mode-enabled',
        },
      },
    }),
    provideRouter(
      appRoutes,
      withPreloading(PreloadAllModules),
      withComponentInputBinding(),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
    ),
  ],
};
